import clientConfig from '@jucy-nakuru/config/clientConfig';
import { getAnalytics } from 'firebase/analytics';
import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { browserLocalPersistence, browserPopupRedirectResolver, initializeAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getPerformance } from 'firebase/performance';
import { getStorage } from 'firebase/storage';

let app: FirebaseApp | null = null;
if (typeof window !== 'undefined') {
    const apps = getApps();
    if (!apps.length) {
        app = initializeApp(clientConfig.firebase);
    } else {
        app = apps[0];
    }
}
export const auth = app
    ? initializeAuth(app, {
          persistence: browserLocalPersistence,
          popupRedirectResolver: browserPopupRedirectResolver,
      })
    : null;
export const firestore = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;
export const performance = app ? getPerformance(app) : null;
export const functions = app ? getFunctions(app) : null;
export const analytics = app ? getAnalytics(app) : null;
